
import Provider from "./tabs-context/Provider";
import Consumer from "./tabs-context/Consumer";

const TabsContext = {
  Provider,
  Consumer
};

export default TabsContext;
